import type { CSSProperties, ReactNode } from "react";
import type { ApiPlayable } from "@hive/sdk";
import type { CatalogueSize, MosaicTile } from "../../lib/catalogueLayout";
import { playableLevel } from "../../lib/catalogueLevel";

export function MosaicTiles<T>({ layout, playable, captioned = false, renderCard }: {
	layout: { tiles: MosaicTile<T>[]; columns: number; rows: number; variant: number };
	playable: (item: T) => ApiPlayable;
	captioned?: boolean;
	renderCard: (item: T, index: number, size: CatalogueSize) => ReactNode;
}) {
	return <div className={"quality-mosaic" + (captioned ? " quality-mosaic--captioned" : "")} data-variant={layout.variant}
		style={{ "--mosaic-columns": layout.columns, "--mosaic-rows": layout.rows } as CSSProperties}>
		{layout.tiles.map(({ item, sourceIndex, size, column, row, span }) => <div key={sourceIndex} className="quality-tile" data-size={size} data-level={playableLevel(playable(item)) ?? "unknown"}
			style={{ gridColumn: `${column + 1} / span ${span}`, gridRow: `${row + 1} / span ${span}` }}>
			{renderCard(item, sourceIndex, size)}
		</div>)}
	</div>;
}
